import { render, staticRenderFns } from "./LoginRegisterDialog.vue?vue&type=template&id=78bebcf6&scoped=true&"
import script from "./LoginRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./LoginRegisterDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoginRegisterDialog.vue?vue&type=style&index=0&id=78bebcf6&prod&lang=less&scoped=true&"
import style1 from "./LoginRegisterDialog.vue?vue&type=style&index=1&id=78bebcf6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bebcf6",
  null
  
)

export default component.exports